import { useCallback, useEffect, useState } from 'react';
import { useTheme } from '../themes/ThemeProvider';
export function useDeviceType() {
    const theme = useTheme();
    const tokens = {
        mobile: theme['grid-tokens-mobile'] || 'grid.mobile',
        tablet: theme['grid-tokens-tablet'] || 'grid.tablet',
        desktop: theme['grid-tokens-desktop'] || 'grid.desktop',
    };
    const xs = parseInt(theme['grid-breakpoint-xs'] || '600', 10);
    const s = parseInt(theme['grid-breakpoint-s'] || '1024', 10);
    const getDeviceType = useCallback((width) => {
        const breakpointL = parseInt(theme['grid-breakpoint-l'] || '1440', 10);
        if (width < xs)
            return 'mobile';
        if (width < s)
            return 'tablet';
        if (width >= s && width > breakpointL)
            return 'desktop-large';
        return 'desktop';
    }, [xs, s, theme]);
    const [deviceType, setDeviceType] = useState(getDeviceType(typeof window !== 'undefined' ? window.innerWidth : 1920));
    useEffect(() => {
        function handleResize() {
            setDeviceType(getDeviceType(window.innerWidth));
        }
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [xs, s, getDeviceType]);
    return {
        deviceType,
        tokens,
    };
}
